import { searchObjectQuery } from 'app/atoms/header';
import type { SpecificNavigationProp, SpecificRouteProp } from 'app/types/navigation';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

export function useListingsSearch({
  navigation,
  route,
}: {
  navigation: SpecificNavigationProp<'all-listings'>;
  route: SpecificRouteProp<'all-listings'>;
}) {
  const setAtomSearch = useSetAtom(searchObjectQuery);
  const search = route.params?.search ?? '';

  // The header displays the route's search param, so the results must use it too.
  // Keep the shared atom in sync when navigation opens listings without a query.
  useEffect(() => {
    setAtomSearch(search);
  }, [search, setAtomSearch]);

  const setSearch = (value: string) => {
    const nextSearch = value.trim();
    setAtomSearch(nextSearch);
    navigation.setParams({ search: nextSearch || undefined });
  };

  return { search, setSearch };
}
